import { IAM, collectionEngineV1 } from '../apis.js';
const collectionEngineAPI = collectionEngineV1('/tenants', false);
const reqIAM = IAM('/tenants', false);
export const createNewTenant = (newTenant) => collectionEngineAPI('POST', `/`, {
    body: newTenant,
});
export const patchTenantsCollectionEngine = (tenantId, patch) => collectionEngineAPI('PATCH', `/${tenantId}`, {
    body: patch,
});
export const getAll = async () => reqIAM('GET', '/?offset=0&limit=5000');
export const get = async (id) => reqIAM('GET', `/${id}`);
export const update = (id, tenant) => reqIAM('PATCH', `/${id}`, {
    body: tenant,
});
export const getSSOOverview = (id) => reqIAM('GET', `/${id}/sso`);
export const createSSOOrganization = (id, body) => reqIAM('POST', `/${id}/sso/organization`, { body });
export const addSSODomain = (id, body) => reqIAM('POST', `/${id}/sso/domains`, { body });
export const updateSSOSettings = (id, body) => reqIAM('PATCH', `/${id}/sso`, { body });
//# sourceMappingURL=tenants.js.map